export default function (totalCharge, quantity, card) {
  gtag("event", "conversion", {
    send_to: "AW-978300184",
    value: totalCharge,
    currency: "USD",
    transaction_id: card?.id,
    quantity,
  });
}
